/**  
 * KycDetailFinalSaveService
 * Page/Class name   : KycDetailFinalSaveService
 * Author            :
 * Created Date      : 23-6-2020
 * Functionality     : constructor, componentDidMount , componentWillUnmount, getTweetRecords
 * Purpose           : api service page
**/
import {Component } from 'react';
// import {getEndPoint,getTokenFromLocStorage, callApi} from  '../../common_utilities/commonjsfunc';
// newly added axios
//import axios from 'axios';
import {axiosCustomObj} from '../customisedthirdparty/AxiosCustom';

import {commonJsFuncModule as commonJsObj} from  '../../common_utilities/commonjsfunc';
const callApi = commonJsObj.callApi;
const getTokenFromLocStorage = commonJsObj.getTokenFromLocStorage;



class KycDetailFinalSaveService extends Component {

    
    /**  
     * KycDetailFinalSaveService
     * Function name : constructor
     * Author        :
     * Created Date  : 23-6-2020
     * Purpose       : initializing state
     * Params        : 
    **/
    constructor() {
      super();
      this.state = {
          
      }

      //this.axiosObj = axios;
      this.axiosObj = null;
      
      this.apiEndPoint = commonJsObj.getEndPoint()+'rest/organisations/kyc/final';
    }

    /**  
     * KycDetailFinalSaveService
     * Function name : componentDidMount
     * Author        :
     * Created Date  : 23-6-2020
     * Purpose       : life cycle method
     * Params        : 
    **/
    componentDidMount() {
    }

    /**  
     * KycDetailFinalSaveService
     * Function name : componentWillUnmount
     * Author        :
     * Created Date  : 23-6-2020
     * Purpose       : life cycle method
     * Params        : 
    **/
    componentWillUnmount() {  
    }



    /**  
     * KycDetailFinalSaveService
     * Function name : saveDetail
     * Author        :
     * Created Date  : 23-6-2020
     * Purpose       : Login check to provide access token 
     * Params        : paramObj
    **/
    async saveDetail(paramObj){
      this.axiosObj = axiosCustomObj({});
      let accToken = getTokenFromLocStorage();     
      try{
            let urldata =this.apiEndPoint;
            

            let headerOptn = {  
              "Content-Type": "application/json",
              "Authorization": accToken
            };          

            let respObj = this.axiosObj.put(urldata,paramObj, {
            headers: headerOptn
            });

            return respObj;
    }
    catch(err){
        console.log("Some error occured===>",err); // TypeError: failed to fetch
    }
      

    }

    
}
export default KycDetailFinalSaveService;